// extracted by mini-css-extract-plugin
export default {"searchInput":"MQgAOU83Nc16NgkTNlJv","foodCardList":"scu4cAlBuRhkh2UzOYl6","emptyListContent":"NfujMWFAvrof7Jk_aYyZ"};